import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('brokerLetterReport', {
  nb: {
    error: 'Det oppsto en feil i ordredataene som forhindret visning av rapporten',
    loading: 'Lasting',
    municipality: 'Kommune',
    owners: 'Eiere',
    name: 'Navn',
    ownershipShare: 'Eierandel',
    nationalRegistryAddress: 'Folkeregistrert adresse',
    role: 'Rolle',
    cadastreInformation: 'Matrikkelinformasjon',
    buildings: 'Bygninger',
    buildingType: 'Bygningstype',
    rental: 'Utleiedel',
    residenceRequirements: 'Boplikt',
    area: 'Areal',
    commonArea: 'Fellesareal',
    plotArea: 'Tomteareal',
    water: 'Vann',
    drain: 'Avløp',
    usableArea: 'Bruksareal (BRA)',
    totalArea: 'Bruttoareal (BTA)',
    builtUpArea: 'Bebygd areal (BYA)',
    constructionCases: 'Byggesaker',
    applicationDate: 'Søknadsdato',
    applicationSubject: 'Søknad gjelder',
    completion: 'Ferdigattest',
    attachments: 'Vedlegg',
    cadastreLetter: 'Matrikkelbrev',
    measureLetter: 'Målebrev',
    disclaimerTitle: 'Om fullstendighet og nøyaktighet i matrikkelutskriften:',
    disclaimerText: `Ambita tar forbehold om at informasjon som hentes fra Matrikkelen kan avvike fra de faktiske
     forhold, og at grensepunkter mv. kan mangle helt eller delvis eller være feil registrert i Matrikkelen.
     Ambitas Matrikkelutskrift viser arealet som er en geometrisk
     beregning basert på eiendommens grenselinjer. I de tilfeller grensene er markert som fiktive brukes i stedet
     oppgitt areal hvis dette finnes i Matrikkelen.
     Ambita er ikke ansvarlig for tap som oppstår som følge av feil i Matrikkelutskriften.`
  },
  'en-us': {
    error: 'There was an error in the order data preventing the display of the report',
    loading: 'Loading',
    municipality: 'Municipality',
    owners: 'Owners',
    name: 'Name',
    ownershipShare: 'Ownership share',
    nationalRegistryAddress: 'National Registry address',
    role: 'Role',
    cadastreInformation: 'Cadastre information',
    buildings: 'Buildings',
    buildingType: 'Building type',
    rental: 'Rental',
    residenceRequirements: 'Residence requirements',
    area: 'Area',
    commonArea: 'Common area',
    plotArea: 'Plot area',
    water: 'Water',
    drain: 'Drain',
    usableArea: 'Usable area (BRA)',
    totalArea: 'Total area (BTA)',
    builtUpArea: 'Built up area (BYA)',
    constructionCases: 'Construction cases',
    applicationDate: 'Application date',
    applicationSubject: 'Application subject',
    completion: 'Completion',
    attachments: 'Attachments',
    cadastreLetter: 'Cadastre letter',
    measureLetter: 'Measure letter',
    disclaimerTitle: 'About the completeness and accuracy of the cadastral statement:',
    disclaimerText: `Ambita reserves the information obtained from the Cadastre may differ from the actual
     circumstances, and the boundary points may be missing entirely or partially or be incorrectly registered
     in the Cadastre. Ambitas cadastral statement shows the area as a geometric calculation based on the
     property’s boundary lines. In those cases where the boundaries are marked as fictional, the given area is used
     – assuming this is available information in the Cadastre.
     Ambita is not liable for losses arising from errors in the cadastral statement.`
  }
});
